import { Button, InfoBar } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import type { SeatBasedTeamSubscription } from "../../../hooks/useTeamsTypes";
import useTranslation from "../../../hooks/useTranslation";
import { calculateDaysLeft } from "../../../utils/convertUtils";
import { formatExpirationDate, getTierDisplayName } from "../subscriptionUtils";

export const TeamGracePeriodBanner: React.FC<{
  className?: string;
  subscription: SeatBasedTeamSubscription;
  handleUpdatePaymentInfo: () => void;
}> = ({ className, subscription, handleUpdatePaymentInfo }) => {
  const { teamID } = useParams();
  const { t, m } = useTranslation();

  if (!subscription.gracePeriodExpirationDate || !teamID) {
    return null;
  }

  const gracePeriodDays = calculateDaysLeft(
    new Date(subscription.gracePeriodExpirationDate),
    new Date()
  );

  const title = t(m.TeamBilling.GracePeriodTitle, { days: gracePeriodDays });

  return (
    <InfoBar
      className={className}
      variant="critical"
      title={title}
      text={t(m.TeamBilling.TeamGracePeriodText, {
        tierName: getTierDisplayName(subscription.tier),
        memberCount: subscription.editorSeatsUsed,
        date: formatExpirationDate(subscription.gracePeriodExpirationDate),
        bold: (chunks: React.ReactNode) => <b>{chunks}</b>,
      })}
      cta={
        <Button variant="grayscale" onClick={handleUpdatePaymentInfo}>
          {t(m.TeamBilling.UpdateCard)}
        </Button>
      }
    ></InfoBar>
  );
};
